<template>
    <div class="print-job">
        <print-loader
            :isMobileDevice="isMobileDevice"
            :loadingState="loadingState"
            @cancel="$emit('cancel')"
            @close="$_onStop()"
        ></print-loader>
        <print-map
            v-if="userSettings.printselection !== 'results' && previewConfig"
            ref="printMap"
            :previewConfig="previewConfig"
            :dpi="dpi"
            mode="print"
            :logo="logo"
            :northarrow="northarrow"
            :userSettings="userSettings"
            :originalMap="map"
            @startPrint="$_onMapReady()"
        />
        <print-extras
            v-if="userSettings.printselection !== 'map'"
            ref="printExtras"
            :previewConfig="previewConfig"
            mode="print"
            :userSettings="userSettings"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { isMobileDevice } from '../../services/utilities/devices';

    import PrintMap from './PrintMap.vue';
    import PrintExtras from './PrintExtras.vue';
    import PrintLoader from './PrintLoader.vue';

    export default {
        name: 'PrintExecuter',
        components: {
            'print-map': PrintMap,
            'print-extras': PrintExtras,
            'print-loader': PrintLoader
        },
        data() {
            return {
                loadingState: {
                    tiles: null,
                    message: null,
                    stage: 1,
                    errors: []
                },
                mapReady: false,
                isPrinting: false,
                isMobileDevice: isMobileDevice()
            };
        },
        props: {},
        created() {
            if (!this.getPrintJob) {
                this.$_onStop();
            }
            this.$store.commit('SET_PAGE_PRINT_SIZE_STYLE');
            // if we only print results we can print immediately
            if (this.userSettings.printselection === 'results') {
                this.$nextTick(() => {
                    // since there is no map, it is ready
                    this.mapReady = true;
                    this.$_onPrint();
                });
            }
        },
        methods: {
            $_onStop() {
                this.$router.push({ name: 'ngMap' });
            },
            $_onMapReady() {
                this.mapReady = true;
            },
            $_onPrint() {
                // if the loading state is inactive (false) and the tiles have been loaded (mapReady) we can print
                if (!this.getLoadingState && this.mapReady && !this.isPrinting) {
                    this.isPrinting = true;
                    this.loadingState.stage = 2;
                    window.print();
                    this.loadingState.stage = 3;
                    if (!this.isMobileDevice) {
                        this.$_onStop();
                    }
                }
            }
        },
        computed: {
            ...mapGetters(['getPrintJob', 'getLoadingState']),
            previewConfig() {
                return this.getPrintJob.previewConfig;
            },
            dpi() {
                return this.getPrintJob.dpi;
            },
            userSettings() {
                return this.getPrintJob.userSettings;
            },
            map() {
                return this.getPrintJob.map;
            },
            logo() {
                return this.getPrintJob.logo;
            },
            northarrow() {
                return this.getPrintJob.northarrow;
            }
        },
        watch: {
            getLoadingState: {
                handler: function (newVal) {
                    if (!newVal) {
                        // set a delay so wfsrequests can be queued
                        setTimeout(this.$_onPrint, 300);
                    }
                },
                immediate: true
            },
            mapReady: {
                handler: function () {
                    this.$_onPrint();
                },
                immediate: true
            }
        }
    };
</script>

<style lang="scss">
.print-job {
    margin: 0;
    padding: 0;
}
@media screen {
    .print-job {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100vh;
    }
}
</style>
